var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 400,
    viewBox: "0 0 375 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4188_57)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 400,
    fill: "url(#paint0_linear_4188_57)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 187,
    y: -352,
    width: 422.85,
    height: 422.85,
    rx: 100,
    transform: "rotate(45 187 -352)",
    fill: "url(#paint1_linear_4188_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4188_57",
    x1: 187.5,
    y1: 0,
    x2: 187.5,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#152C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0251FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4188_57",
    x1: 423.498,
    y1: -165.648,
    x2: 673.142,
    y2: 83.9963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A42CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A42CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4188_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSection);
export default __webpack_public_path__ + "static/media/hero-section.3115cad33b69bcbf4eab00fccab87e6c.svg";
export { ForwardRef as ReactComponent };